const CubeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_43)">
        <g clipPath="url(#clip1_14_43)">
          <path
            d="M11.2441 3.2002C11.7328 3.02441 12.2672 3.02441 12.7594 3.2002L19.5094 5.61191C20.4023 5.93184 21 6.7791 21 7.73184V16.2678C21 17.217 20.4023 18.0678 19.5059 18.3877L12.7559 20.7994C12.2672 20.9752 11.7328 20.9752 11.2406 20.7994L4.49063 18.3877C3.59766 18.0678 3 17.2205 3 16.2678V7.73184C3 6.78262 3.59766 5.93184 4.49414 5.61191L11.2441 3.2002ZM12 5.32012L5.89336 7.4998L12 9.67949L18.1066 7.4998L12 5.32012ZM13.125 18.2787L18.75 16.2713V9.66191L13.125 11.6693V18.2787Z"
            fill="#0051FF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_14_43">
          <rect width="18" height="18" fill="white" transform="translate(3 3)" />
        </clipPath>
        <clipPath id="clip1_14_43">
          <path d="M3 3H21V21H3V3Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CubeIcon;
